import { render, staticRenderFns } from "./TestQuestion.vue?vue&type=template&id=24ecc87a&"
import script from "./TestQuestion.vue?vue&type=script&lang=js&"
export * from "./TestQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports